var map = {
	"./data-server-1.png": 786,
	"./data-server-2.png": 787,
	"./data-server-3.png": 788,
	"./data-server-4.png": 789,
	"./data-server-5.png": 790,
	"./data-server-6.png": 791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1932;